"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enlarge = void 0;
var enlarge = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 0h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 16v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 16h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
    }
  }]
};
exports.enlarge = enlarge;